'use strict';

const base = require('capencyBase/capency/email/capency.verify.email');

/**
 *
 * @param {*} result
 * @param {*} callback
 */
window.capency = {};

/**
 * Checks the email property result by making an AJAX request and handles the response.
 * Provides autocomplete suggestions if applicable and manages validation feedback.
 *
 * @param {jQuery} $emailSelector - jQuery object representing the email input field.
 * @param force boolean telling if validation must be made even if the field has not been edited
 * @returns {Promise<boolean>} A promise that resolves to true if the email is valid or suggestions are provided,
 *                             and rejects with an error message if the email is invalid.
 * @description
 * This function sends a GET request to a specified URL to check the validity of an email address.
 * If the email is invalid, it displays an error message and focuses on the input field.
 * If suggestions are available, it initializes an autocomplete feature on the input field.
 * The function returns a promise that resolves if the email is valid or suggestions are provided,
 * and rejects if there is an error in the validation process.
 */
function checkEmailPropertyResult($emailSelector, force = false) {
    return new Promise((resolve, reject) => {
        if (!$emailSelector.data('isModified') && !force) {
            if ($emailSelector.data('isError')) {
                $emailSelector.addClass('is-invalid');
                $emailSelector.toggleClass('autocomplete-field-selected', false);
                $emailSelector.focus();
                reject(new Error($emailSelector.next('.invalid-feedback').html()));
            } else {
                resolve(true);
            }
            return;
        }

        var urlCapCheckEmailProp = $('#url-cap-email-check-email-prop').val();
        var capData = {
            sMail: $emailSelector.val()
        };

        $.ajax({
            url: urlCapCheckEmailProp,
            type: 'GET',
            data: capData,
            success: function (result) {
                if (result.returnCode && result.returnCode > 0) {
                    if (result.returnCode === 1) {
                        $emailSelector.next('.invalid-feedback').empty().html(result.sMessage).show();
                        $emailSelector.addClass('is-invalid');
                        $emailSelector.toggleClass('autocomplete-field-selected', false);
                        $emailSelector.focus();
                        $emailSelector.data('isModified', false);
                        $emailSelector.data('isError', true);
                        reject(new Error(result.sMessage));
                    } else if (result.mail) {
                        if (result.returnCode === 2) {
                            var finalDatasource = $.map(result.mail, function (item) {
                                return {
                                    label: item.sMail,
                                    value: item.sMail
                                };
                            });

                            $emailSelector.autocomplete({
                                create: function () {
                                    $(this).attr('autocomplete', 'off');
                                },
                                minLength: 0,
                                autoFocus: true,
                                source: function (request, response) {
                                    response(finalDatasource);
                                },
                                select: function (event, ui) {
                                    let $this = $(this);
                                    $this.next().html(ui.item.sMail);
                                    $this.toggleClass('autocomplete-field-selected', true);
                                    $this.removeClass('is-invalid');
                                    $this.data('isModified', true);
                                    $(this).next('.invalid-feedback').empty();
                                    resolve(true);
                                },
                                appendTo: '#' + $emailSelector.parents('form').attr('id')
                            })

                            $emailSelector.focus();
                            $emailSelector.autocomplete('search', '');
                            reject(false);
                        }
                    }
                } else {
                    $emailSelector.data('isModified', false);
                    $emailSelector.data('isError', false);
                    resolve(true);
                }
            },
            error: function (error) {
                reject(new Error('Error during email verification: ' + error));
            }
        });
    });
}

base.checkEmailPropertyResult = checkEmailPropertyResult;

module.exports = base;
